import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

export default function MobileDrawer({ open, setOpen, user, logout, t, locale, setLocale, locales, totalItems }) {
  if (!open) return null;
  const close = () => setOpen(false);

  return (
    <div className="md:hidden border-t border-border bg-background px-6 py-4 space-y-2 animate-fade-in">
      {/* Navigation */}
      <Link to="/catalog" onClick={close} className="block text-sm font-medium text-foreground hover:text-primary py-1">{t.nav.catalog}</Link>
      {user?.role === 'admin' && (
        <Link to="/admin/products" onClick={close} className="block text-sm font-medium text-foreground hover:text-primary py-1">{t.nav.admin}</Link>
      )}
      {user?.role === 'admin' && (
        <Link to="/ops" onClick={close} className="block text-sm font-medium text-foreground hover:text-primary py-1">Ops</Link>
      )}

      {/* Cart */}
      <div className="pt-2 border-t border-border">
        <Link to="/cart" onClick={close} className="flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary py-1">
          <ShoppingCart className="w-4 h-4" /><span>Winkelmand</span>
          {totalItems > 0 && <span className="w-5 h-5 text-[10px] bg-accent text-accent-foreground rounded-full flex items-center justify-center font-bold">{totalItems}</span>}
        </Link>
      </div>

      {/* Auth */}
      <div className="pt-2 border-t border-border space-y-2">
        {user ? (
          <>
            <Link to="/account" onClick={close} className="block text-sm font-medium text-foreground hover:text-primary py-1">{t.nav.myAccount}</Link>
            <button onClick={() => { logout(); close(); }} className="block text-sm text-muted-foreground hover:text-foreground py-1">{t.nav.logout}</button>
          </>
        ) : (
          <div className="flex items-center gap-3">
            <Link to="/login" onClick={close} className="text-sm font-medium text-foreground hover:text-primary">{t.nav.login}</Link>
            <Link to="/register" onClick={close} className="bg-primary text-primary-foreground rounded-full px-4 py-1.5 text-sm font-medium">{t.nav.register}</Link>
          </div>
        )}
      </div>

      {/* Language */}
      <div className="pt-2 border-t border-border flex items-center gap-2">
        {locales.map((l, i) => (
          <span key={l} className="flex items-center gap-1">
            <button onClick={() => { setLocale(l); close(); }} className={`text-xs uppercase font-semibold ${locale === l ? 'text-primary' : 'text-muted-foreground'}`}>{l}</button>
            {i < locales.length - 1 && <span className="text-border text-xs">|</span>}
          </span>
        ))}
      </div>
    </div>
  );
}
